export default __webpack_public_path__ + "7e668c58b0e6b8105db440a988d30573.png";